<template>
  <div class="lwdh-box">
	<div class="inRoomLiwu-box lwdh-slide-in"
	      v-for="(item,index) in inLwList" 
	      :key="`lw-${index}`"
	      :style="{zIndex: 10 - index}">
	    <div class="inRoomLiwu-box-left">
	    	<img :src="item.details.sendUserInfo.headPortrait"></img>
			<div class="inRoomLiwu-box-left-content">
				<span class="inRoomLiwu-box-left-content-span">{{item.details.sendUserInfo.nickName}}:</span>
				<div class="inRoomLiwu-box-left-content-div">
					<span class="inRoomLiwu-box-left-content-div-span">{{$t('all.songgei')}}</span>
					<span class="inRoomLiwu-box-left-content-div-span1">{{item.details.toUserInfo.nickName}}</span>
				</div>
			</div>
	    </div>
		<div class="inRoomLiwu-box-right">
			<img class="inRoomLiwu-box-right-img" :src="item.details.giftInfo.imgUrl"></img>
			<div class="inRoomLiwu-box-right-num">
				<span class="inRoomLiwu-box-right-num-span">×</span>
				<span class="inRoomLiwu-box-right-num-span1">{{item.details.num}}</span>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  inLwList:[],
	  lwQueue:[],
	  isLwAnimating: false,
	  animateTotalTime: 3000,
	  animateGap: 100,
    };
  },
  mounted() {
	
  },
  methods: {
	addLwToQueue(gift) {
		this.lwQueue.push(gift);
		if (!this.isLwAnimating) {
			this.showNextLw();
		}
	},
	showNextLw() {
		if (this.lwQueue.length === 0) {
			this.isLwAnimating = false;
			return;
		}
		
		this.isLwAnimating = true;
		const gift = this.lwQueue.shift();
		this.inLwList.push(gift);
		
		setTimeout(() => {
			this.inLwList = this.inLwList.filter(item => item.giftId !== gift.giftId);
			setTimeout(() => {
				this.showNextLw();
			}, this.animateGap);
		}, this.animateTotalTime);
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./liwudonghua.css";
	@keyframes slideIn {
		0% {
			transform: translateX(0); /* 初始位置就是 left: -232px */
			opacity: 0;
		}
		100% {
			/* 修改点 2: 将元素从 left: -232px 移动到 left: 20px 的位置 */
			transform: translateX(calc(100% + 20px));
			opacity: 1;
		}
	}
	
	@keyframes slideOut {
		0% {
			/* 从 slideIn 结束的位置和状态开始 */
			transform: translateX(calc(100% + 20px));
			opacity: 1;
			/* 修改点 3: 初始时显示完整元素 */
			clip-path: inset(0 0 0 0);
		}
		100% {
			/* 保持位置不变 */
			transform: translateX(calc(100% + 20px));
			opacity: 0;
			/* 修改点 3: 最终将元素的右侧 100% 区域裁剪掉，实现从右到左消失 */
			clip-path: inset(0 100% 0 0);
		}
	}
</style>


// WEBPACK FOOTER //
// liwudonghua.vue?cf42d188